import { NaniumObject, Type } from 'nanium/objects';

export class Account extends NaniumObject<Account> {
	@Type(String) id?: string;
	@Type(String) accountNumber?: number;
	@Type(String) email: string;
	@Type(String) passwordHash?: string;
	@Type(Date) creationDate?: Date;
	@Type(Date) lastContact?: Date;
	@Type(String) activationCode?: string;
	@Type(String) passwordResetCode?: string;
	@Type(Array, String) roles?: Role[];
	@Type(Array, String) rights?: Right[];
	@Type(Boolean) subscribedToNewsletter: boolean;
	@Type(String) name?: string;
	@Type(Boolean) termsAndConditionsAccepted?: boolean;

	hasRole(role: Role) {
		return this.roles?.includes(role);
	}

	hasOneRole(...roles: Role[]) {
		return roles.some(r => this.roles?.includes(r));
	}
}

export const TOKEN_TYPES = [
	'normal',
	'longLife',
	'ip',
] as const;
export type TokenType = typeof TOKEN_TYPES[number];

export class Token extends NaniumObject<Token> {
	@Type(String) id: string;
	@Type(String) secret: string;
	@Type(Number) lifeTime: number; // in seconds
	@Type(String) type: TokenType;
	@Type(String) accountId: string;
	@Type(Date) validTo: Date;
}

export const Rights = ['receiveExportMails'] as const;
export type Right = typeof Roles[number];

export const Roles = ['applicant', 'reviser', 'contact', 'news', 'university', 'earlyAccess', 'approver', 'finance'] as const;
export type Role = typeof Roles[number];
